import { useState, useMemo } from "react";
import { useGBPAccountsList } from "../../hooks/useGBPGroups";
import ErrorBanner from "../../../../components/sharedcomponents/ErrorBanner";
import GBPPerformance from "../../../performance/GBPPerformance";
import GBPGroupsSelector from "./GBPGroupsSelector";

interface Props {
  onNavigateToGBP: (accountId?: string) => void;
  searchQuery?: string;
  subjectEmail: string;  
}

const GroupssSection: React.FC<Props> = ({
  onNavigateToGBP,
  searchQuery = "",
  subjectEmail,  
}) => {
  const { data: accounts = [], isLoading, isError, error } =
    useGBPAccountsList(subjectEmail); 

  const [perfAccountName, setPerfAccountName] = useState<string>();
  const [perfRegionName,  setPerfRegionName]  = useState<string>();

  const filteredAccounts = useMemo(() => {
    if (!searchQuery.trim()) return accounts;
    const q = searchQuery.toLowerCase();
    return accounts.filter(
      (acc) =>
        acc.name.toLowerCase().includes(q) ||
        acc.id.toLowerCase().includes(q) ||
        acc.resourceName.toLowerCase().includes(q)
    );
  }, [accounts, searchQuery]);

  const handleSelect = (id: string) => {
    sessionStorage.setItem("gbp_selected_account_id", id);
    onNavigateToGBP(id);
  };

  const errorMsg = isError ? (error as any)?.response?.data?.message : null;

  return (
    <div className="mb-8">
      {errorMsg && <ErrorBanner message={errorMsg} />}

      {isLoading ? (
        <div className="flex justify-center py-10">Chargement...</div>
      ) : (
       <GBPGroupsSelector
  accounts={filteredAccounts}
  onSelect={handleSelect}
  onPerformance={(resource, name) => {
    setPerfAccountName(resource);
    setPerfRegionName(name);
  }}
  subjectEmail={subjectEmail}  
/>
      )}

      {perfAccountName && (
        <GBPPerformance
          accountName={perfAccountName}
          ficheName={perfRegionName}
          subjectEmail={subjectEmail} 
          onClose={() => {
            setPerfAccountName(undefined);
            setPerfRegionName(undefined);
          }}
        />
      )}
    </div>
  );
};

export default GroupssSection;